export default "assets/images/icons/success-991e5bf2.svg";